import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateAnchorPoint } from "../../../../actions/index";
import AnchorLeft from "./AnchorLeft";
import AnchorCenter from "./AnchorCenter";
import AnchorRight from "./AnchorRight";
import ItemTypes from "../../../../constants/ItemTypes";

class AnchorPoints extends React.Component {
  handeUpdateAnchorPoint = (payload) => {
    this.props.updateAnchorPoint(payload);
  };

  render() {
    return (
      <div className="textfield__anchor">
        <h4>Anchor Point</h4>
        <ul className="tool__options tool__options--anchor">
          <AnchorLeft
            textElement={this.props.textElement}
            layerId={this.props.layerId}
            anchor_point={this.props.textElement.anchor_point}
            handeUpdateAnchorPoint={this.handeUpdateAnchorPoint}
            itemType={ItemTypes.TEXT}
          />
          <AnchorCenter
            textElement={this.props.textElement}
            layerId={this.props.layerId}
            anchor_point={this.props.textElement.anchor_point}
            handeUpdateAnchorPoint={this.handeUpdateAnchorPoint}
            itemType={ItemTypes.TEXT}
          />
          <AnchorRight
            textElement={this.props.textElement}
            layerId={this.props.layerId}
            anchor_point={this.props.textElement.anchor_point}
            handeUpdateAnchorPoint={this.handeUpdateAnchorPoint}
            itemType={ItemTypes.TEXT}
          />
        </ul>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateAnchorPoint,
    },
    dispatch,
  );
}

export default connect(null, mapDispatchToProps)(AnchorPoints);
